import ApiService from './api.service'
import ReferencesService from './references.sevice'

const DutyFreeWebsiteService = {
	/**
	 * Fetch products list for DutyFree website manager
	 * @param {Object} payload - { page, limit, keyword, categoryId, groupId, visibilityStatus, departmentId }
	 */
	fetchProducts(payload) {
		const page = payload.page || 1
		const limit = payload.limit || 20
		return ApiService.post(`/dutyfree-website/items?page=${page}&limit=${limit}`, payload)
			.catch(() => {
				// Fallback to item search if dedicated endpoint is not yet active on backend
				return ApiService.post(`/item/search/categories?page=${page}&limit=${limit}`, {
					name: payload.keyword || '',
					categoryId: payload.categoryId || null,
					subCategoryId: payload.groupId || null
				})
			})
	},

	/**
	 * Update single item website visibility status
	 * @param {Number|String} itemId 
	 * @param {Boolean} isVisible 
	 */
	updateVisibility(itemId, isVisible) {
		return ApiService.post(`/dutyfree-website/items/${itemId}/visibility`, { isVisible })
			.catch(() => {
				return ApiService.put(`/item/edit/${itemId}`, { isWebsiteVisible: isVisible })
			})
	},

	/**
	 * Bulk update website visibility
	 * @param {Array} itemIds 
	 * @param {Boolean} isVisible 
	 */
	updateBulkVisibility(itemIds, isVisible) {
		return ApiService.post(`/dutyfree-website/items/bulk-visibility`, { itemIds, isVisible })
	},

	/**
	 * Update global or item specific price department
	 * @param {Number|String} departmentId 
	 */
	saveWebsiteDepartmentSetting(departmentId) {
		return ApiService.post(`/dutyfree-website/settings/department`, { departmentId })
	},

	/**
	 * Get website settings (e.g. active price department)
	 */
	getWebsiteSettings() {
		return ApiService.get(`/dutyfree-website/settings`)
	},

	/**
	 * Fetch list of leaf departments for price display selection
	 */
	fetchDepartments() {
		return ApiService.post(`/department/list`, {})
			.catch(() => ApiService.get(`/department/list`))
	},

	/**
	 * Fetch Group options (children of reference 'MAGAZIN' or 'WAREHOUSE_CATEGORY')
	 */
	async fetchMagazinGroups() {
		try {
			// First attempt directly by parent code 'MAGAZIN'
			const res = await ApiService.get(`/references/MAGAZIN/list`)
			if (res && res.data && res.data.length > 0) {
				return res.data
			}
		} catch (e) {
			// Fallback
		}

		try {
			// Find reference with code 'MAGAZIN' inside WAREHOUSE_CATEGORY
			const catRes = await ReferencesService.getReferenceChildren('WAREHOUSE_CATEGORY')
			if (catRes && catRes.data) {
				const magazinRef = catRes.data.find(el => el.code === 'MAGAZIN' || el.name === 'MAGAZIN')
				if (magazinRef && magazinRef.id) {
					const subRes = await ReferencesService.getSubReferenceChildren(magazinRef.id)
					return subRes.data || []
				}
			}
		} catch (e) {
			console.warn('Error fetching Magazin Groups:', e)
		}

		return []
	},

	/**
	 * Fetch Category options (children of selected Group ID)
	 * @param {Number|String} groupId 
	 */
	async fetchCategoriesByGroup(groupId) {
		if (!groupId) return []
		try {
			const res = await ReferencesService.getSubReferenceChildren(groupId)
			return res.data || []
		} catch (e) {
			console.warn('Error fetching Categories for group:', groupId, e)
			return []
		}
	},

	/**
	 * Public Integration API: Get Categories for DutyFree Website
	 */
	getPublicCategories() {
		return ApiService.get(`/api/public/dutyfree-website/categories`)
	},

	/**
	 * Public Integration API: Get Products with Prices for DutyFree Website
	 * @param {Object} params - { categoryId, page, limit, departmentId }
	 */
	getPublicProducts(params = {}) {
		const queryParams = new URLSearchParams(params).toString()
		return ApiService.get(`/api/public/dutyfree-website/products?${queryParams}`)
	}
}

export default DutyFreeWebsiteService
